import { store } from '@/store/store'
import axios from 'axios'
import config from '../config'

const instance = () =>
  axios.create({
    baseURL: `${config.serverUrl}`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })

const yasaleAcApi = {
  getBranch: (request) => {
    const { config } = request
    return instance().get('/yasale-ac/getBranchWithFilter', config)
  },
  importBranch: (request) => {
    const { data } = request
    return instance().post('/yasale-ac/importBranch', data)
  },
  deleteBranch: (request) => {
    const { data } = request
    return instance().delete(`/yasale-ac/deleteBranch/${data.id}`)
  },
  getAdminUser: (request) => {
    const { config } = request
    return instance().get('/yasale-ac/adminuser', config)
  },
  createAdminUser: (request) => {
    const { data } = request
    return instance().post('/createAdminUser', data)
  },
  deleteAdminUser: (request) => {
    const { data } = request
    return instance().delete('/adminusers', { data })
  },
  updateAdminUser: (request) => {
    const { data } = request
    return instance().put('/changeprivilegeadminuser', data)
  },
  getLineNotifyConnectList: (request) => {
    const { config } = request
    return instance().get('/yasale-ac/getLineNotiConnectList', config)
  },
  deleteLineNotify: (request) => {
    return instance().delete(`/linenotify`, request)
  },
  getBranchOptions: (request) => {
    const { config } = request
    return instance().get('/yasale-ac/get-branch', config)
  },
  getRequest: (request) => {
    const { config } = request
    return instance().get('/yasale-ac/getRequestList', config)
  },
  getEngineer: (request) => {
    const { config } = request
    return instance().get('/yasale-ac/getEngineer', config)
  },
  deleteEngineer: (request, member_id) => {
    const { data } = request
    return instance().delete(`/yasale-ac/deleteEngineer/${member_id}`, { params: data })
  },
  getRequestWithLog: (request) => {
    const { config } = request
    return instance().get(`/yasale-ac/getRequestWithLogByMemberId`, config)
  }
}
export default yasaleAcApi



// WEBPACK FOOTER //
// ./src/api/yasale-ac.js